export default __webpack_public_path__ + "static/media/practice-test-8.b7f2a41e.csv";